export default __webpack_public_path__ + "static/media/drum.8f075c06.svg";